<template>
    <header class="header header--top" :class="{open:registerbarIsOpen}">
      <Transition name="registerbar">
        <div class="registerbar" v-if="registerbarIsOpen" @click="registerbarClose"><span class="pc-only">すべての機能を無料で使える！</span>今すぐ無料アカウント登録<span class="close"><i class="las la-times"></i></span></div>
      </Transition>
      <div class="header--top__inner">
        <div class="header__left">
          <div class="header__logo">
            <nuxt-link :to="{ name: 'index' }">
              <img class="" src="/frontend/img/logo-c.svg" srcset="/frontend/img/logo-c.svg 1x, /frontend/img/logo-c.svg 2x"
                alt="会社手続きナビゲーター モチカケ">
            </nuxt-link>
          </div>
        </div>
        <div class="header__right">
          <div class="header__button" @click="menuToggle">
            <span></span>
            <span></span>
            <p>メニュー</p>
          </div>
          <div class="header__menu" :class="{ open: menuIsOpen }">
            <ul>
              <li><nuxt-link to="/function">機能</nuxt-link></li>
              <!-- <li><nuxt-link to="#price">料金プラン</nuxt-link></li> -->
              <li><nuxt-link to="/contact">お問い合わせ</nuxt-link></li>
              <li><nuxt-link to="/resources">お役立ち資料</nuxt-link></li>
              <li><nuxt-link to="/auth/login">ログイン</nuxt-link></li>
              <li class="register"><nuxt-link class="button button--menu" to="/auth/register">無料ではじめる<i
                    class="las la-chevron-circle-right"></i></nuxt-link></li>
            </ul>
          </div>
        </div>
      </div>
    </header>
</template>

<script>
export default {
  name: 'f-header-lp-top',
  data: () => ({
    menuIsOpen: false,
    registerbarIsOpen: false
  }),
  mounted() {
    window.addEventListener('resize', this.handleResize);
    if (!sessionStorage.barClosed) {
      this.registerbarIsOpen = true
    }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    '$route'() {
      this.menuIsOpen = false;
    }
  },
  methods: {
    menuToggle() {
      this.menuIsOpen = !this.menuIsOpen;
    },
    handleResize() {
      if (window.innerWidth < 960) {
        this.menuIsOpen = false;
      } else {
        this.menuIsOpen = true;
      }
    },
    registerbarClose() {
      sessionStorage.setItem('barClosed', true);
      this.registerbarIsOpen = !this.registerbarIsOpen
    }
  }
}
</script>
